/** Retain IDs across transport reconnects; discard them when the active session changes. */
export class ResponseDeduplicator {
  private sessionId: string | null = null;
  private readonly seen = new Set<string>();
  setSession(sessionId: string): void {
    if (sessionId !== this.sessionId) {
      this.sessionId = sessionId;
      this.seen.clear();
    }
  }
  accept(sessionId: string, exchangeId?: string): boolean {
    if (this.sessionId !== sessionId) return false;
    if (!exchangeId) return true; // Older servers remain compatible.
    if (this.seen.has(exchangeId)) return false;
    this.seen.add(exchangeId);
    return true;
  }
}
